<template>
	<el-drawer :modal="false"  title="Repayment Detail" :visible.sync="is_visible" class="drawer-redemption-detail" size="50%" @closed="hide()">
		<div slot="title">
			<b-row align-h="between" align-v="center">
				<b-col lg="4">
					<span>Repayment Detail</span>
				</b-col>
				<!-- <b-col lg="4">
					<div class="d-flex align-items-center text-primary float-right cursor-pointer">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
							<path fill="currentColor"
								d="m12 16-5-5 1.4-1.45 2.6 2.6V4h2v8.15l2.6-2.6L17 11l-5 5Zm-6 4q-.825 0-1.413-.588T4 18v-3h2v3h12v-3h2v3q0 .825-.588 1.413T18 20H6Z" />
						</svg>
						<p class="text-primary ml-2">Export Excel</p>
					</div>
				</b-col> -->
			</b-row>
		</div>
		<b-container v-loading="is_loading">
			<b-row>
				<b-col cols="12">
					<div class="d-flex align-items-center">
						<b-col cols="auto" class="px-1 flex-grow-1">
							<span class="text-xs">Formula Set</span>
							<h3>Rule 78</h3>
						</b-col>
						<b-col cols="auto" class="px-1">
							<el-button type="primary" plain size="mini" @click="$refs.doc_repayment_export.show(tableData)">
								<i class="fa fa-download"></i> Export To PDF
							</el-button>
						</b-col>
						<b-col cols="auto" class="px-1">
							<el-button type="primary" plain size="mini" @click="$refs.doc_repayment_export.exportToExcel(tableData)" >
								<i class="fa fa-download"></i> Export To Excel
							</el-button>
						</b-col>
						<b-col cols="auto" class="px-1">
							<el-button type="danger" plain size="mini" @click="recalculate()" >
								<i class="fa fa-calculator"></i> Recalculate
							</el-button>
						</b-col>
					</div>
				</b-col>
			</b-row>
			<div class="card-table-simple">
				<b-table-simple responsive class="mb-0">
					<b-thead>
						<b-tr>
							<b-th>Instalment Month</b-th>
							<!-- <b-th>Sts</b-th> -->
							<b-th>Due Date</b-th>
							<b-th>Repayment Amt.</b-th>
							<b-th>Principal</b-th>
							<b-th>Interest</b-th>
							<b-th>Accum. Month</b-th>
							<b-th>Late Charges</b-th>
							<b-th>Balance</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr v-for="(data, index) in tableData" :key="index">
							<b-td>Continuance {{ data.instalment_mth }}</b-td>
							<!-- <b-td>{{ data.paid_status }}</b-td> -->
							<b-td>{{ _gHlp.formatMomentDate(data.due_date,'D MMM, YYYY') }}</b-td>
							<b-td>{{ data.repayment_amt | moneyFormatter }}</b-td>
							<b-td>{{ data.principal_amt | moneyFormatter }}</b-td>
							<b-td>{{ data.interest_amt | moneyFormatter }}</b-td>
							<b-td class="text-right">{{ data.accumulate_mth }}</b-td>
							<b-td>{{ data.late_charge_amt | moneyFormatter }}</b-td>
							<b-td>{{ data.balance_amt | moneyFormatter }}</b-td>
						</b-tr>
					</b-tbody>
					<b-tfoot>
						<b-tr class="bg-warning">
							<b-td colspan="2">Total</b-td>
							<b-td>{{ total_repayment | moneyFormatter }}</b-td>
							<b-td>{{ total_principal | moneyFormatter }}</b-td>
							<b-td>{{ total_interest | moneyFormatter }}</b-td>
							<b-td></b-td>
							<b-td>{{ total_late_charge | moneyFormatter }}</b-td>
							<b-td>{{ 0 | moneyFormatter }}</b-td>
						</b-tr>
					</b-tfoot>
				</b-table-simple>
			</div>
		</b-container>
		<DocRepaymentExport ref="doc_repayment_export" />
	</el-drawer>
</template>
<script>
import { Drawer, Button } from 'element-ui'
import DocRepaymentExport from '@/views/CreditLoanCase/DocTemplate/DocRepaymentExport';
import { cloneDeep } from 'lodash'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { swal } from '@/assets/js/httpImports.js';

export default {
	components: {
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		DocRepaymentExport
	},
	data() {
		return {
			is_loading:false,	
			is_visible: false,
			tableData: []
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase','activeRepayments']),
		total_repayment(){
			if(_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.repayment_amt), 0);
		},
		total_principal(){
			if(_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.principal_amt), 0);
		},
		total_interest(){
			if(_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.interest_amt), 0);
		},
		total_late_charge(){
			if(_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.late_charge_amt), 0);
		},
		total_balance(){
			if(_gHlp.isEmpty(this.tableData)) return 0;
			return this.tableData.reduce((accumulator, currentItem) => accumulator + parseFloat(currentItem.balance_amt), 0);
		},
	},
	methods: {
		...mapActions(useLoanCaseStore, ['getRepayList','updateCase']),
		show() {
			this.is_visible = true;
			this.getListing();
		},
		hide() {
			this.is_visible = false;
			this.tableData = [];
		},
		getListing(refresh = false) {
			if(_gHlp.isEmpty(this.activeRepayments) || refresh){
				this.is_loading = true;
				this.getRepayList().then(resp => {
					this.tableData = resp;
					this.is_loading = false;
				}).catch(err => {
					this.is_loading = false;
				})
			}else{
				this.tableData = cloneDeep(this.activeRepayments)
			}
    },
		recalculate(){
			const html = 'This action will do process : <ul>'
				+'<li>Repair Case Summary & Collection Status</li>'
				+'<li>Regenerate Repayment Listing</li>'
				+'<li>Recalculate Disbursement</li>'
				+'<li>Recalculate Collection</li>'
				+'<li>Regenerate Statement Listing</li>'
				+'<li>And Recheck Late Charge Payment If exist</li>';
				+'</ul>';

			swal.fire({
				title: 'Recalculate Confirmation',
				html: html,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
						_gNotif.notifySuccess("Case has updated")
						this.getListing(true);
					}).catch((e) => {
						_gNotif.notifyError('Failed regenerate repayment');
						this.is_loading = false;
					})
				}
			});
		}
	}
}
</script>